import { ApiClient } from '~admin/client/api-client';
import { Config } from '~admin/config';
import { clearPersistedStorage } from '~admin/service/persistence';

export const apiClient = new ApiClient({
  baseURL: Config.isDebugBuild ? '/api' : Config.api,
  withCredentials: !Config.isDebugBuild,
  unauthorizedCallback: (): void => {
    // TODO(Dmitry): Temp solution to deal with 401 and 403
    clearPersistedStorage();
    // Refreshes the page to trigger AuthenticatedRoute redirect
    location.reload();
  },
});



// WEBPACK FOOTER //
// ./client/index.ts